import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs')({
  beforeLoad: () => getTitleContextSlice('Factor Rule Runs'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
